/* Lumisia — interakcje motywu */
(function () {
  'use strict';
  var L = window.LUMI || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- pieniądze (wg formatu sklepu) ---------- */
  function formatMoney(cents) {
    var fmt = L.moneyFormat || '{{amount_with_comma_separator}} zł';
    cents = Math.round(cents || 0);
    function group(num, dec, th, ds) {
      var parts = (num / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(cents, 2, ' ', '.');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, '.', ',');
      }
    });
  }
  L.formatMoney = formatMoney;

  /* ---------- wybuch emotek (konfetti) ---------- */
  var burstSet = ['🌈', '⭐', '✨', '💖', '🎨', '🌟', '💜', '💛', '💙'];
  function burst(x, y, count) {
    if (reduceMotion) return;
    count = count || 16;
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      s.className = 'lumi-burst';
      s.textContent = burstSet[i % burstSet.length];
      var ang = (Math.PI * 2 * i) / count + Math.random() * 0.4;
      var dist = 70 + Math.random() * 90;
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      s.style.setProperty('--tx', Math.cos(ang) * dist + 'px');
      s.style.setProperty('--ty', Math.sin(ang) * dist - 40 + 'px');
      s.style.setProperty('--r', (Math.random() * 360 - 180) + 'deg');
      document.body.appendChild(s);
      setTimeout(function (el) { el.remove(); }, 1000, s);
    }
  }
  function burstFrom(el, count) {
    var r = el.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2, count);
  }
  L.burst = burst;

  /* ---------- pasek ogłoszeń ---------- */
  function initAnn(root) {
    var msgs = root.querySelectorAll('.lumi-ann__msg');
    if (msgs.length < 2) return;
    var i = 0, ms = (parseInt(root.getAttribute('data-interval'), 10) || 4) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, ms);
  }

  /* ---------- pojawianie się przy przewijaniu ---------- */
  var io = null;
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.lumi-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- płynne przewijanie do zakupu ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lumi-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace('#', '');
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- karty rozmiarów → wybór w boksie ---------- */
  function norm(s) { return String(s || '').toLowerCase().replace(/×/g, 'x').replace(/\s|cm/g, ''); }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-lumi-size]');
    if (!c) return;
    document.dispatchEvent(new CustomEvent('lumi:size', { detail: { match: c.getAttribute('data-lumi-size') } }));
    var buy = document.getElementById('lumi-buy');
    if (buy) buy.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- boks zakupowy ---------- */
  function initBuy(root) {
    if (root.__lumi) return; root.__lumi = true;
    var dataEl = root.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }
    var form = root.querySelector('[data-lumi-form]');
    if (!form) return;
    var cta = root.querySelector('[data-cta]');
    var ctaText = root.querySelector('[data-cta-text]');
    var ctaLabel = root.getAttribute('data-cta') || 'Dodaj do koszyka';
    var errEl = root.querySelector('[data-err]');
    var low = parseInt(root.getAttribute('data-low'), 10) || 0;
    var after = root.getAttribute('data-after') || 'cart';
    var mainImg = root.querySelector('[data-lumi-main]');
    var sizeBtns = root.querySelectorAll('.lumi-size');
    var activeSize = root.querySelector('.lumi-size.is-active');
    var current = null;
    var startId = activeSize ? parseInt(activeSize.getAttribute('data-variant'), 10) : null;
    variants.forEach(function (v) { if (v.id === startId) current = v; });
    if (!current) current = variants.filter(function (v) { return v.available; })[0] || variants[0];

    function pack() {
      var r = form.querySelector('.lumi-pack__radio:checked');
      return {
        qty: r ? parseInt(r.getAttribute('data-qty'), 10) || 1 : 1,
        disc: r ? parseFloat(r.getAttribute('data-disc')) || 0 : 0
      };
    }
    function priceFor(v, qty, disc) {
      var regular = v.price * qty;
      var now = regular - Math.round(regular * disc / 100);
      var base = Math.max(v.price, v.compare || 0) * qty;
      return { now: now, old: base > now ? base : 0 };
    }
    function setText(sel, txt, scope) {
      var el = (scope || root).querySelector(sel);
      if (el) el.textContent = txt;
      return el;
    }

    function render() {
      if (!current) return;
      var pk = pack();
      // ceny w kartach zestawów
      form.querySelectorAll('.lumi-pack').forEach(function (card) {
        var r = card.querySelector('.lumi-pack__radio');
        var q = parseInt(r.getAttribute('data-qty'), 10) || 1;
        var d = parseFloat(r.getAttribute('data-disc')) || 0;
        var pr = priceFor(current, q, d);
        setText('[data-now]', formatMoney(pr.now), card);
        var o = card.querySelector('[data-old]');
        if (o) { o.textContent = pr.old ? formatMoney(pr.old) : ''; }
        setText('[data-unit]', formatMoney(Math.round(pr.now / q)) + ' / szt.', card);
      });
      // suma
      var p = priceFor(current, pk.qty, pk.disc);
      setText('[data-total]', formatMoney(p.now));
      var oldEl = setText('[data-total-old]', p.old ? formatMoney(p.old) : '');
      var save = root.querySelector('[data-save]');
      if (save) {
        if (p.old) { save.textContent = 'Oszczędzasz ' + formatMoney(p.old - p.now) + ' 🎉'; save.hidden = false; }
        else save.hidden = true;
      }
      setText('[data-sbar-price]', formatMoney(p.now));
      setText('[data-sbar-name]', (pk.qty > 1 ? pk.qty + ' × ' : '') + current.title);
      setText('[data-size-name]', current.title);
      // dostępność i stan
      cta.disabled = !current.available;
      ctaText.textContent = current.available ? ctaLabel + ' · ' + formatMoney(p.now) : 'Chwilowo wyprzedane';
      var stock = root.querySelector('[data-stock]');
      if (stock) {
        if (current.available && current.inv !== null && current.inv > 0 && current.inv <= low) {
          stock.innerHTML = '<span class="lumi-buy__pulse"></span> Zostało tylko <b>' + current.inv + ' szt.</b> w rozmiarze ' + current.title;
          stock.hidden = false;
        } else if (current.available) {
          stock.innerHTML = '<span class="lumi-buy__pulse is-green"></span> Dostępna od ręki — szybka wysyłka';
          stock.hidden = false;
        } else stock.hidden = true;
      }
    }

    function selectVariant(id, fromUser) {
      variants.forEach(function (v) { if (v.id === id) current = v; });
      sizeBtns.forEach(function (b) {
        var on = parseInt(b.getAttribute('data-variant'), 10) === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (current && current.img && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = current.img; }
      if (fromUser && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', id);
        history.replaceState({}, '', u.toString());
      }
      render();
    }

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        selectVariant(parseInt(b.getAttribute('data-variant'), 10), true);
        burstFrom(b, 8);
      });
    });
    form.querySelectorAll('.lumi-pack__radio').forEach(function (r) {
      r.addEventListener('change', function () { render(); burstFrom(r.closest('.lumi-pack'), 10); });
    });
    document.addEventListener('lumi:size', function (e) {
      var m = norm(e.detail && e.detail.match);
      if (!m) return;
      var hit = variants.filter(function (v) { return norm(v.title).indexOf(m) > -1; })[0];
      if (hit) selectVariant(hit.id, true);
    });

    // przyklejone zdjęcie główne wyśrodkowane w pionie w oknie (pod nagłówkiem); miniaturki mogą zejść niżej
    var media = root.querySelector('.lumi-buy__media');
    var frame = root.querySelector('.lumi-buy__frame');
    var annEl = document.querySelector('.lumi-ann');
    var hdrEl = document.querySelector('.lumi-header');
    function sizeMedia() {
      // rozmiar zdjęcia liczony od pełnej wysokości paska ogłoszeń + nagłówka (stan na górze strony)
      var chrome = (annEl ? annEl.offsetHeight : 0) + (hdrEl ? hdrEl.offsetHeight : 0);
      document.documentElement.style.setProperty('--lumi-chrome', chrome + 'px');
      fitMedia();
    }
    function fitMedia() {
      if (!media || !frame) return;
      if (window.innerWidth < 900) { media.style.top = ''; return; }
      // wyśrodkuj zdjęcie między dolną krawędzią nagłówka a dołem okna (na bieżąco, bo pasek ogłoszeń znika przy przewijaniu)
      var hb = hdrEl ? Math.max(0, hdrEl.getBoundingClientRect().bottom) : 0;
      media.style.top = Math.round(hb + Math.max(8, (window.innerHeight - hb - frame.offsetHeight) / 2)) + 'px';
    }
    sizeMedia();
    window.addEventListener('resize', sizeMedia);
    window.addEventListener('load', sizeMedia);
    window.addEventListener('scroll', fitMedia, { passive: true });

    // miniaturki
    var thumbs = root.querySelector('[data-lumi-thumbs]');
    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.lumi-buy__thumb');
        if (!btn) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = btn.getAttribute('data-full');
        thumbs.querySelectorAll('.lumi-buy__thumb').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    }

    // dodaj do koszyka
    function addToCart(srcBtn) {
      if (!current || !current.available) return;
      errEl.hidden = true;
      var pk = pack();
      cta.setAttribute('aria-busy', 'true');
      var root2 = L.root || '/';
      if (root2.slice(-1) !== '/') root2 += '/';
      fetch(root2 + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: pk.qty }] })
      })
        .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.d && (r.d.description || r.d.message)) || 'Nie udało się dodać do koszyka.');
          burstFrom(srcBtn || cta, 24);
          setTimeout(function () { window.location.href = root2 + (after === 'checkout' ? 'checkout' : 'cart'); }, reduceMotion ? 0 : 550);
        })
        .catch(function (e) {
          cta.removeAttribute('aria-busy');
          errEl.textContent = e.message || 'Wystąpił błąd. Spróbuj ponownie.';
          errEl.hidden = false;
        });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(cta); });

    // dolny pasek (telefon)
    var sbar = root.querySelector('[data-sbar]');
    var sbcta = root.querySelector('[data-sbar-cta]');
    if (sbcta) sbcta.addEventListener('click', function () { addToCart(sbcta); });
    if (sbar) {
      var ticking = false;
      var upd = function () {
        var r = cta.getBoundingClientRect();
        var show = r.bottom < 0;
        sbar.classList.toggle('is-visible', show);
        sbar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sbcta) sbcta.tabIndex = show ? 0 : -1;
        ticking = false;
      };
      window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(upd); ticking = true; } }, { passive: true });
      upd();
    }

    // wariant z adresu (?variant=)
    var q = new URLSearchParams(window.location.search).get('variant');
    if (q) selectVariant(parseInt(q, 10), false); else render();
  }

  /* ---------- licznik promocji ---------- */
  function initPromo(root) {
    if (root.__lumi) return; root.__lumi = true;
    var end = parseInt(root.getAttribute('data-end'), 10) * 1000;
    if (!end) return;
    var el = {
      d: root.querySelector('[data-d]'), h: root.querySelector('[data-h]'),
      m: root.querySelector('[data-m]'), s: root.querySelector('[data-s]'),
      dUnit: root.querySelector('[data-unit-d]')
    };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var timer;
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { clearInterval(timer); root.remove(); return; }
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      el.d.textContent = pad(d); el.h.textContent = pad(h); el.m.textContent = pad(m); el.s.textContent = pad(s);
      if (el.dUnit) el.dUnit.hidden = d === 0;
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- interaktywna tablica ---------- */
  var LED = [
    { name: 'ciepły', c: '#ffcf6b' },
    { name: 'różowy', c: '#ff6fb5' },
    { name: 'błękitny', c: '#4fd3ff' },
    { name: 'fioletowy', c: '#b47bff' },
    { name: 'tęcza', c: 'rainbow' }
  ];
  function initDraw(root) {
    if (root.__lumi) return; root.__lumi = true;
    var board = root.querySelector('[data-board]');
    var canvas = root.querySelector('[data-canvas]');
    var hint = root.querySelector('[data-hint]');
    var hand = root.querySelector('[data-hand]');
    if (!board || !canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var color = '#ff4fa3', drawing = false, last = null, dpr = 1, drew = false;
    var strokes = [];

    function resize() {
      var r = board.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      redraw();
    }
    function seg(a, b, c) {
      var w = Math.max(5, board.clientWidth / 90);
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      // jasny rdzeń na wierzchu, poświata zawsze POD istniejącymi liniami (bez efektu „przerywanej” linii)
      ctx.globalCompositeOperation = 'source-over';
      ctx.shadowBlur = 0;
      ctx.strokeStyle = 'rgba(255,255,255,.6)'; ctx.lineWidth = w * 0.3;
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.strokeStyle = c; ctx.lineWidth = w;
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      ctx.shadowColor = c; ctx.shadowBlur = 20;
      ctx.strokeStyle = c; ctx.lineWidth = w;
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      ctx.shadowBlur = 0;
      ctx.globalCompositeOperation = 'source-over';
    }
    function redraw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var W = board.clientWidth, H = board.clientHeight;
      strokes.forEach(function (s) {
        for (var i = 1; i < s.pts.length; i++) {
          seg({ x: s.pts[i - 1][0] * W, y: s.pts[i - 1][1] * H }, { x: s.pts[i][0] * W, y: s.pts[i][1] * H }, s.c);
        }
      });
    }
    function pos(e) {
      var r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    canvas.addEventListener('pointerdown', function (e) {
      drawing = true; last = pos(e);
      canvas.setPointerCapture && canvas.setPointerCapture(e.pointerId);
      strokes.push({ c: color, pts: [[last.x / board.clientWidth, last.y / board.clientHeight]] });
      seg(last, { x: last.x + 0.1, y: last.y + 0.1 }, color);
      if (!drew) { drew = true; board.classList.add('is-drawn'); }
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!drawing) return;
      var p = pos(e);
      seg(last, p, color);
      strokes[strokes.length - 1].pts.push([p.x / board.clientWidth, p.y / board.clientHeight]);
      last = p;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
      canvas.addEventListener(t, function () { drawing = false; });
    });

    root.querySelectorAll('.lumi-pen').forEach(function (b) {
      b.addEventListener('click', function () {
        color = b.getAttribute('data-color');
        root.querySelectorAll('.lumi-pen').forEach(function (x) {
          var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    });
    var ledIdx = 0;
    var ledBtn = root.querySelector('[data-led-btn]');
    function applyLed() {
      var l = LED[ledIdx];
      board.setAttribute('data-led', ledIdx);
      root.style.setProperty('--led', l.c === 'rainbow' ? '#ff8ad8' : l.c);
      board.classList.toggle('is-rainbow', l.c === 'rainbow');
      if (ledBtn) ledBtn.querySelector('span').textContent = 'Światło: ' + l.name;
    }
    if (ledBtn) ledBtn.addEventListener('click', function () { ledIdx = (ledIdx + 1) % LED.length; applyLed(); });
    applyLed();
    var clear = root.querySelector('[data-clear]');
    if (clear) clear.addEventListener('click', function () {
      strokes = []; redraw(); drew = false; board.classList.remove('is-drawn');
    });
    var save = root.querySelector('[data-save]');
    if (save) save.addEventListener('click', function () {
      var out = document.createElement('canvas');
      out.width = canvas.width; out.height = canvas.height;
      var o = out.getContext('2d');
      o.fillStyle = '#140f2e'; o.fillRect(0, 0, out.width, out.height);
      o.drawImage(canvas, 0, 0);
      var a = document.createElement('a');
      a.download = 'moj-rysunek-lumisia.png';
      a.href = out.toDataURL('image/png');
      a.click();
      burstFrom(save, 12);
    });
    if (hand && reduceMotion) hand.remove();

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(resize, 150); });
    resize();
  }

  /* ---------- start ---------- */
  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-lumi-ann]').forEach(initAnn);
    scope.querySelectorAll('[data-lumi-buy]').forEach(initBuy);
    scope.querySelectorAll('[data-lumi-promo]').forEach(initPromo);
    scope.querySelectorAll('[data-lumi-draw]').forEach(initDraw);
    initReveal(scope);
  }
  function boot() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
